export function formValidate(formsObj) {
  let forms = (formsObj && formsObj.length) ? formsObj : $('.gift-cards_form');

  $.validator.addMethod("phone", function (value, element) {
    return this.optional(element) || value === "NA" ||
      value.match(/^[0-9()\-+ ]+$/);
  }, "Please enter a valid number, or 'NA'");

  $.validator.addMethod(
    "pattern",
    function (value, element, regexp) {
      var re = new RegExp(regexp);
      return this.optional(element) || re.test(value);
    },
    "Incorrect value."
  );

  function addClass(input, isReversClass) {
    let
      notValidClass = 'not-valid',
      validClass = 'valid',
      firstClass = isReversClass ? notValidClass : validClass,
      secondClass = isReversClass ? validClass : notValidClass;

    input.addClass(firstClass).removeClass(secondClass).closest('.input-wrap').addClass(firstClass).removeClass(secondClass);
  }


  forms.each(function () {
    let $thisForm = $(this).attr('novalidate', true), rules = {};

    if (!$thisForm.data('dataValidate')) {
      $thisForm.find('[required]').each(function () {
        let
          $this = $(this),
          obj = {required: true};

        // $this.closest('.form-item').addClass('required').append('<u class="icon-cross-small"></u>');

        if ($this.is('[minlength]')) {
          obj.minlength = $this.attr('minlength');
        }

        if ($this.is('[maxlength]')) {
          obj.maxlength = $this.attr('maxlength');
        }

        if ($this.is('[pattern]')) {
          obj.pattern = $this.attr('pattern');
        }

        if ($this.is('[type=email]')) {
          obj.email = true;
        }

        if ($this.is('[type=url]')) {
          obj.url = true;
        }

        rules[$this.attr('name')] = obj;
      });

      $thisForm.data('dataValidate', ($thisForm.validate({
        rules: rules,
        ignore: [],
        errorElement: 'div',
        errorClass: "error-text",
        validClass: "valid-text",
        normalizer: function (value) {
          return $.trim(value);
        },
        highlight: function (element/*, errorClass, validClass*/) {
          addClass($(element), true);
        },
        unhighlight: function (element/*, errorClass, validClass*/) {
          addClass($(element));
        }
      })));
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/formValidate.js